/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';
import {Navbar  , Nav , NavDropdown} from 'react-bootstrap'

import BootstrapTable from 'react-bootstrap-table-next';



export default class Lessons extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"active",
            toggle:false,
        };
    }

    componentWillUnmount(){

    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.tab)
        {
            case "students" : return <h4>Students</h4>
            case "staff" : return <h4>Students</h4>
        }
    }

    renderOptions(cell, row){

        return    <NavDropdown className="pull-right" style={{padding:'0px' , margin:'0px'}} drop={"down"} title="Options" id="basic-nav-dropdown">
            <NavDropdown.Item href="#action/3.4">Lesson</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">Start Lesson</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.3">Edit</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Duplicate</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Share</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Archive</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Delete</NavDropdown.Item>
        </NavDropdown>

    }

    renderProfileLink(cell, row){
        return <a href="#">{cell}</a>
    }

    render(){

        const products = [ {date:"2050-10-10" , "passowrd":"super password" , "username":"markie04004040" , "id":"1000" , "name":"Mark James Smith" }, {date:"2050-10-10" , "passowrd":"super password" , "username":"markie04004040" , "price":"0.00" , "id":"2000" , "name":"Mark James Smith" }, {date:"2050-10-10" , "passowrd":"super password" , "username":"markie04004040" , "price":"0.00" ,"id":"3000" , "name":"Mark James Smith"} ];
        const columns = [{
            dataField: 'name',
            text: 'Name',
            formatter: this.renderProfileLink.bind(this),
        },
            {
                dataField: 'price',
                text: 'Summary',
            },
            {
                dataField: 'date',
                text: 'Type'
            },
            {
                dataField: 'price',
                text: 'Planned Date',
            },

            {
                dataField: 'price',
                text: '',
                align:'right',
                classes: 'options-row',
                headerClasses: 'options-row',
                formatter: this.renderOptions.bind(this),
            }

        ];

        return <div>
            <Navbar style={{padding:0}}>
                <Nav defaultActiveKey={this.state.tab} onSelect={k => this.handleSelect(k)}>
                    <Nav.Item>
                        <Nav.Link style={{paddingLeft:"0"}} eventKey="active">Active</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link style={{paddingLeft:"0"}} eventKey="lessons">Archived</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Navbar.Collapse className="justify-content-end">
                    <Nav.Link style={{paddingLeft:"0"}} eventKey="lessons">Create a lesson</Nav.Link>
                </Navbar.Collapse>
            </Navbar>
            <hr/>
            <div>
                <BootstrapTable bordered={ false } keyField='id' data={ products } columns={ columns } />
            </div>
        </div>
    }
}
